"use strict";
exports.__esModule = true;
var so_rich_text_box_component_1 = require("../../../../../../components/so-rich-text-box/so-rich-text-box.component");
angular.module('smartorg.r6.acts.introBox', [
    so_rich_text_box_component_1["default"],
]).filter("trustit", ['$sce', function ($sce) {
        return function (htmlCode) {
            return $sce.trustAsHtml(htmlCode);
        };
    }]);
require('./intro-box-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.acts.introBox';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/intro-box/app/js/plumbing/app.js